import React from "react";
import { useTranslation } from "react-i18next";

import { TextInput, Checkbox } from "fe-shared/src/components";

import styles from "./InvalidationControls.module.scss";

interface Props {
  isWithCheckbox: boolean;
  invalidationReason: string;
  setInvalidationReason: (value: string) => void;
  isShowToParticipant: boolean;
  setShowToParticipant: (value: boolean) => void;
  isReasonTooLong: boolean;
  characterLimitText: string;
}

const InvalidationControls = (props: Props) => {
  const {
    isWithCheckbox,
    invalidationReason,
    setInvalidationReason,
    isShowToParticipant,
    setShowToParticipant,
    isReasonTooLong,
    characterLimitText,
  } = props;
  const { t } = useTranslation();

  return (
    <>
      <TextInput
        required
        isMultiline
        value={invalidationReason}
        isError={isReasonTooLong}
        wrapperClassName={styles.textInput}
        title={t("actions.Invalidate.reasonInputTitle")}
        id="invalidation-dialog-reason-input"
        onChange={(e, value) => setInvalidationReason(value)}
        errorText={
          isReasonTooLong
            ? `${t(
                "transactions.actions.characterLimit"
              )} ${characterLimitText}`
            : ""
        }
      />
      {isWithCheckbox && (
        <Checkbox
          id="invalidation-dialog-checkbox"
          title={t("actions.Invalidate.checkboxText")}
          onChange={(e, value) => setShowToParticipant(value)}
          value={isShowToParticipant}
          wrapperClassName={styles.checkbox}
        />
      )}
    </>
  );
};

export default InvalidationControls;
